import React from 'react'
import Slider from 'react-slick'
import { get } from 'lodash'
import { Col, Container, Row } from 'react-bootstrap'

import TagBanner from 'components/molecules/TagBanner'
import Typography from 'components/atoms/Typography'
import { userCheckMobileScreen } from 'helpers/tools'

import './CarouselTagBanners.scss'
import 'slick-carousel/slick/slick.css'

function CarouselTagBanners({ data }) {
  const themeClasses = get(data, 'theme.entity.classes')
  const items = get(data, 'items')
  const sliderSettings = {
    dots: true,
    dotsClass: 'slick-dots primary',
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px',
        },
      },
    ],
  }

  return (
    <Container fluid className={`carousel-tag-banners  py-3 ${themeClasses || 'bg-gray-400'}`}>
      <Container>
        <Row className="mb-3">
          <Col sm={12} md={8}>
            <Typography variant="h2" cssClass="carousel-tag-banners__title title-semibold-xs">
              {get(data, 'title')}
            </Typography>
          </Col>
        </Row>
        <Slider {...sliderSettings}>
          {items &&
            items.map(({ entity }) => (
              <TagBanner
                alt={get(entity, 'image.entity.images.alt')}
                className="carousel-tag-banners__item"
                src={
                  userCheckMobileScreen()
                    ? get(entity, 'image.entity.images.large.url')
                    : get(entity, 'image.entity.images.wide.url')
                }
                title={get(entity, 'title')}
                themeClasses={get(entity, 'theme.entity.classes')}
                key={get(entity, 'uuid')}
                footer={{
                  title: get(entity, 'link.title'),
                  url: get(entity, 'link.url.path'),
                }}
              />
            ))}
        </Slider>
      </Container>
    </Container>
  )
}

export default CarouselTagBanners
